import LocationPriceComparisonChart from '../charts/LocationPriceComparisonChart';
import ProductPriceComparisonChart from '../charts/ProductPriceComparisonChart';
import BasketPriceComparisonChart from '../charts/BasketPriceComparisonChart';
import EstablishmentPriceComparisonChart from '../charts/EstablishmentPriceComparisonChart';

interface ComparativeTabProps {
  t: (key: string) => string;
}
const ComparativeTab = ({ t }: ComparativeTabProps) => {  
  return (
    <div className="tab trend-explorer-tab flex flex-col gap-10 px-2 pt-8 md:px-8 md:pt-12 lg:pt-14">      
      <ProductPriceComparisonChart t={t}/>
      <BasketPriceComparisonChart t={t}/>
      <LocationPriceComparisonChart t={t}/>
      <EstablishmentPriceComparisonChart t={t}/>
    </div>
  );
};

export default ComparativeTab;
